import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Blockquote = styled.blockquote`
  width: 100%;
  text-align: center;
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 10px;
  }
`;

export default Blockquote;



// WEBPACK FOOTER //
// ./src/styled-components/Blockquote.js